import { render, staticRenderFns } from "./ManageNewRequestRow.vue?vue&type=template&id=6b23faf0&"
import script from "./ManageNewRequestRow.vue?vue&type=script&lang=js&"
export * from "./ManageNewRequestRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports